<template>
  <div class="page">
    <a-table
      :columns="columns"
      :row-key="(record) => record.id"
      :data-source="dataSource"
      size="small"
    ></a-table>
  </div>
</template>

<script setup>
  import { defineProps, computed } from 'vue'
  import dayjs from 'dayjs'
  const props = defineProps({
    data: {
      type: Array,
      default: () => [],
    },
  })
  const dataSource = computed(() => props.data)
  const columns = [
    {
      title: 'No',
      dataIndex: 'no',
      key: 'no',
      customRender({ index }) {
        return index + 1
      },
      width: '5%',
    },
    {
      title: 'Obj ID',
      dataIndex: 'objectId',
      width: '15%',
    },
    {
      title: 'Req.Reg.',
      dataIndex: 'reqRegionCode',
      width: '15%',
    },

    {
      title: 'Pick Reg.',
      dataIndex: 'pickRegionCode',
      width: '15%',
    },
    {
      title: 'Job ID',
      dataIndex: 'jobId',
      width: '20%',
    },
    {
      title: 'Job Status',
      dataIndex: 'jobStatus',
      width: '10%',
    },
    {
      title: 'Req.Delivery Time',
      dataIndex: 'expPickTime',
      width: '20%',
      customRender({ text }) {
        return dayjs(text).format('YYYY/MM/DD HH:mm')
      },
    },
  ]
</script>
